// @flow

import OfferAPI from 'api/OfferAPI';

export const offerCompareOffers = (application_id: number, history: any) => {
  return(dispatch: any) => {
    return OfferAPI.getCompareOffers(application_id);
  }
}

export const offerSaveCompareOffers = (application_id: number, data: any, history: any) => {
  return(dispatch: any) => {
    return OfferAPI.postCompareOffers(application_id, data);
  }
}

export const offerSetCurrent = (application: any) => {
  return(dispatch: any) => {
    return dispatch({ type: 'SET_CURRENT_APPLICATION', payload: application });
  }
}

export const getOfferView = (id: number) => {
  return(dispatch: any) => {
    return OfferAPI.getOfferView(id);
  }
}



// WEBPACK FOOTER //
// ./src/actions/offer/offer.js